export const ApiConfig = {
  apiKeyToken: "abfed367-b96e-4792-8f7c-485b5385736a"
};
